import clsx from "clsx";
import { FormattedMessage } from "react-intl";

const NewTag = () => {
  return (
    <span
      className={clsx(
        "theme-accent",
        "vst-tag",
        "vst-tag-size-tiny",
        "vst-tag-variant-dark",
        "vst-tag-option-strong"
      )}
    >
      <FormattedMessage defaultMessage="New" />
    </span>
  );
};

export default NewTag;
